<template>
<file-layout :show-header="true" :allow-share="false">
		<div class="exception">
			<div class="message-box">
				<div class="message">
					<img v-if="currenState === 'FILE_NOT_FOUND'" src="@/assets/h5/notfound.png" />
					<svg-icon v-else-if="currenState === 'FILE_NO_AUTH'" icon-class="auth-lock"
						class="auth-lock"></svg-icon>
					<svg-icon v-else-if="currenState === 'FILE_DELETED'" icon-class="file-deleted"
						class="file-deleted"></svg-icon>
					<svg-icon v-else-if="currenState === 'FILE_EMPTY'" icon-class="file-no-content"
						class="file-no-content"></svg-icon>
					<svg-icon v-else-if="currenState === 'FILE_EXPIRED'" icon-class="file-expired"
						class="file-expired"></svg-icon>
					<div>
						<span>{{ message }}</span>
					</div>
				</div>
			</div>
			<div class="empty"></div>
		</div>
	</file-layout>
</template>

<script>
import { intl } from 'tci18n-vue2'
import FileLayout from '@/components/h5/Layout';
export default {
  props: {
    message: {
      type: String
    }
  },
  components: {
    FileLayout
  },
  computed: {
    currenState() {
      if (this.message === intl.$t("没有访问权限#!!!#src/pages/H5/Cloud/components/Message.vue_1")) {
        return 'FILE_NO_AUTH';
      } else if (this.message === intl.$t("该文件已损坏或已被删除#!!!#src/pages/H5/Cloud/components/Message.vue_1")) {
        return 'FILE_DELETED';
      } else if (this.message === intl.$t("该链接已经过期#!!!#src/pages/H5/Cloud/components/Message.vue_1")) {
        return 'FILE_EXPIRED';
      } else if (this.message === '') {
        return 'FILE_EMPTY';
      } else {
        return 'FILE_NOT_FOUND';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.exception {
	height: 100%;
	display: flex;
	flex-direction: column;

	.message-box {
		height: 50%;
		display: flex;
		align-items: flex-end;
		justify-content: center;

		.message {
			text-align: center;

			img {
				width: 120px;
			}

			span {
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
				color: #A2A4B0;
				text-align: center;
			}

			.auth-lock {
				width: 127px;
				height: 106px;
				margin-bottom: 16px;
			}

			.file-deleted {
				width: 130px;
				height: 120px;
				margin-bottom: 16px;
			}

			.file-no-content {
				width: 120px;
				height: 120px;
				margin-bottom: 16px;
			}

			.file-expired {
				width: 120px;
				height: 120px;
				margin-bottom: 16px;
			}
		}
	}

	.empty {
		height: 50%;
	}
}
</style>
